import React, { useState } from 'react'
import { ICONS, ICON_SCALE } from '../globals'
import styled from 'styled-components'

const chunk = (arr: any[], size: number) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size)
  )
const formatNumberLabel = (text: number) =>
  (+(text + ''.trim().toLocaleUpperCase())).toFixed(1)

const markerShape =
  'M12.5-22.7A12.3,12.3,0,0,1,6.6-12.3C4.2-11,1.4-8.5,1.4,0H-1.4c0-8.5-2.8-11-5.2-12.3a12.3,12.3,0,0,1-5.9-10.4A12.4,12.4,0,0,1,0-35,12.4,12.4,0,0,1,12.5-22.7Z'

const Container = styled.g``
const Marker = styled.path`
  stroke: #fff;
  stroke-width: 1;
  cursor: pointer;
`
const LabelConnector = styled.line`
  stroke: #a09c8a;
  stroke-width: 0.5;
`
const Label = styled.text`
  font-family: var(--chart-font-stack);
  font-weight: 200;
  font-size: 12px;
  letter-spacing: 0.3px;
  pointer-events: none;
`
const LabelGroup = styled.g``

const polyY = -50
const polyS = 8

export const CategoryVizMarker = ({
  x,
  y,
  color,
  label,
  code,
  labelAnchor = 'start',
  value,
  alwaysLabeled = false,
  isMarked = false
}: {
  x: number
  y: number
  color: string
  label: string | string[]
  code: string
  labelAnchor: 'start' | 'end' | 'middle'
  value: number
  alwaysLabeled?: boolean
  isMarked?: boolean
}) => {
  const [ishovered, sethovered] = useState(false)

  const ismultilabel = typeof label !== 'string'

  return (
    <Container transform={`translate(${x},${y - 4})`}>
      {isMarked && (
        <polygon
          points={[
            [polyS, polyY],
            [-polyS, polyY],
            [0, polyY + polyS]
          ].join(' ')}
          fill='#000'
        />
      )}
      <Marker
        transform={`scale(1)`}
        fill={color}
        d={markerShape}
        onMouseMove={() => sethovered(true)}
        onMouseLeave={() => sethovered(false)}
      />
      <Label textAnchor='middle' y={-18} fill={'#fff'}>
        {code}
      </Label>
      {ishovered && (
        <LabelGroup transform={`translate(${0},${-80})`}>
          <Labeling label={label} value={value} anchor={labelAnchor} top />
        </LabelGroup>
      )}
      {alwaysLabeled && !ishovered && (
        <LabelGroup transform={`translate(${0},${55})`}>
          <Labeling label={label} value={value} anchor={labelAnchor} />
          {/* <LabelConnector y1={-18} y2={-38} /> */}
        </LabelGroup>
      )}
    </Container>
  )
}

const Labeling = ({
  label,
  value,
  anchor,
  top = false
}: {
  label: string | string[]
  value: number
  anchor: 'start' | 'end' | 'middle'
  top: boolean
}) => {
  let labelrows = [[label]]
  if (typeof label !== 'string' && label.length > 5)
    labelrows = chunk(
      label.sort((a, b) => a.localeCompare(b)) as string[],
      Math.ceil(label.length / 2)
    )
  return (
    <>
      <Label textAnchor={anchor} y={top ? (labelrows.length - 1) * -16 : 0}>
        {labelrows.map((m, i) => (
          <tspan x={0} dy={16 * i}>
            {m
              .join(',')
              .trim()
              .toLocaleUpperCase()}
          </tspan>
        ))}
        <tspan x={0} dx={0} dy={16}>
          {formatNumberLabel(value)}
        </tspan>
      </Label>
      <LabelConnector y1={top ? 24 : -18} y2={top ? 40 : -38} />
    </>
  )
}
